import {
  emptySetcxexqki71qfa as emptySet,
  setOf45ia9pnfhe90 as setOf,
} from '../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Companion_getInstanceidce664s8rcz as Companion_getInstance,
  EventType2bd9gu34l4i61 as EventType,
  Companion_getInstance2a6946bmnnmyk as Companion_getInstance_0,
} from './notifications/shared.mjs';
import { setOf1u3mizs95ngxo as setOf_0 } from '../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { plus1ogy4liedzq5j as plus } from '../../../kotlin-kotlin-stdlib/kotlin/collections/_Sets.mjs';
import {
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  get_shortDisplayNamenwyz2dxtvf5g as get_shortDisplayName,
  HasDisplayName3s4kfsms5h38b as HasDisplayName,
} from './supportModels.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  MemberRole_Manager_getInstance3dbaoot8q9evq as MemberRole_Manager_getInstance,
  MemberRole_Admin_getInstance3iiznt2spfc6m as MemberRole_Admin_getInstance,
  MemberRole_Employee_getInstance37kv78awnpbvk as MemberRole_Employee_getInstance,
} from './enums.mjs';
import { startsWith26w8qjqapeeq6 as startsWith } from '../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { substringAfter35b3qhto7hchb as substringAfter } from '../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var EventClass;
function Event() {
  if (EventClass === VOID) {
    class $ {
      constructor(name, tags, displayName, description) {
        tags = tags === VOID ? emptySet() : tags;
        displayName = displayName === VOID ? name : displayName;
        description = description === VOID ? null : description;
        this.j9g_1 = name;
        this.k9g_1 = tags;
        this.l9g_1 = displayName;
        this.m9g_1 = description;
      }
      e90() {
        return this.l9g_1;
      }
      h94() {
        return new (EventType())(this.j9g_1, plus(this.k9g_1, !(this.l9g_1 === this.j9g_1) ? setOf_0(displayName(Companion_getInstance(), this.l9g_1)) : emptySet()));
      }
      toString() {
        return 'Event(name=' + this.j9g_1 + ', tags=' + toString(this.k9g_1) + ', displayName=' + this.l9g_1 + ', description=' + this.m9g_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.j9g_1);
        result = imul(result, 31) + hashCode(this.k9g_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.l9g_1) | 0;
        result = imul(result, 31) + (this.m9g_1 == null ? 0 : getStringHashCode(this.m9g_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Event()))
          return false;
        if (!(this.j9g_1 === other.j9g_1))
          return false;
        if (!equals(this.k9g_1, other.k9g_1))
          return false;
        if (!(this.l9g_1 === other.l9g_1))
          return false;
        if (!(this.m9g_1 == other.m9g_1))
          return false;
        return true;
      }
    }
    protoOf($).d90 = get_shortDisplayName;
    initMetadataForClass($, 'Event', VOID, VOID, [HasDisplayName()]);
    EventClass = $;
  }
  return EventClass;
}
var WithRemindersClass;
function WithReminders() {
  if (WithRemindersClass === VOID) {
    class $ {
      constructor(name, tags, reminderName, reminderTags, displayName, reminderDisplayName, description, reminderDescription) {
        tags = tags === VOID ? emptySet() : tags;
        reminderName = reminderName === VOID ? 'Reminder: ' + name : reminderName;
        reminderTags = reminderTags === VOID ? tags : reminderTags;
        displayName = displayName === VOID ? name : displayName;
        reminderDisplayName = reminderDisplayName === VOID ? displayName + ' Reminders' : reminderDisplayName;
        description = description === VOID ? null : description;
        reminderDescription = reminderDescription === VOID ? null : reminderDescription;
        this.n9g_1 = name;
        this.o9g_1 = tags;
        this.p9g_1 = reminderName;
        this.q9g_1 = reminderTags;
        this.r9g_1 = displayName;
        this.s9g_1 = reminderDisplayName;
        this.t9g_1 = description;
        this.u9g_1 = reminderDescription;
      }
      v9g() {
        return new (Event())(this.n9g_1, this.o9g_1, this.r9g_1, this.t9g_1);
      }
      w9g() {
        return new (Event())(this.p9g_1, this.q9g_1, this.s9g_1, this.u9g_1);
      }
      toString() {
        return 'WithReminders(name=' + this.n9g_1 + ', tags=' + toString(this.o9g_1) + ', reminderName=' + this.p9g_1 + ', reminderTags=' + toString(this.q9g_1) + ', displayName=' + this.r9g_1 + ', reminderDisplayName=' + this.s9g_1 + ', description=' + this.t9g_1 + ', reminderDescription=' + this.u9g_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.n9g_1);
        result = imul(result, 31) + hashCode(this.o9g_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.p9g_1) | 0;
        result = imul(result, 31) + hashCode(this.q9g_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.r9g_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.s9g_1) | 0;
        result = imul(result, 31) + (this.t9g_1 == null ? 0 : getStringHashCode(this.t9g_1)) | 0;
        result = imul(result, 31) + (this.u9g_1 == null ? 0 : getStringHashCode(this.u9g_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof WithReminders()))
          return false;
        if (!(this.n9g_1 === other.n9g_1))
          return false;
        if (!equals(this.o9g_1, other.o9g_1))
          return false;
        if (!(this.p9g_1 === other.p9g_1))
          return false;
        if (!equals(this.q9g_1, other.q9g_1))
          return false;
        if (!(this.r9g_1 === other.r9g_1))
          return false;
        if (!(this.s9g_1 === other.s9g_1))
          return false;
        if (!(this.t9g_1 == other.t9g_1))
          return false;
        if (!(this.u9g_1 == other.u9g_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'WithReminders');
    WithRemindersClass = $;
  }
  return WithRemindersClass;
}
var SharedEventsClass;
function SharedEvents() {
  if (SharedEventsClass === VOID) {
    class $ {
      constructor() {
        SharedEvents_instance = this;
        this.x9g_1 = new (Event())('Project Status Updated');
        this.y9g_1 = new (Event())('Project Message Sent');
        this.z9g_1 = new (Event())('Project Published', setOf(['FOR CONTRACTORS EXCLUSIVELY', requiresRole(Companion_getInstance_0(), MemberRole_Manager_getInstance())]));
        this.a9h_1 = new (Event())('Project Accepted', setOf(['FOR CONTRACTORS EXCLUSIVELY', requiresRole(Companion_getInstance_0(), MemberRole_Manager_getInstance())]));
        this.b9h_1 = new (WithReminders())('Project Pending Start', setOf(['FOR CONTRACTORS EXCLUSIVELY', get_CONTRACTOR_REQUIRED(Companion_getInstance_0()), requiresRole(Companion_getInstance_0(), MemberRole_Manager_getInstance())]));
        this.c9h_1 = new (WithReminders())('Incident Submitted', setOf([get_REQUIRED(Companion_getInstance_0()), requiresRole(Companion_getInstance_0(), MemberRole_Manager_getInstance())]));
        this.d9h_1 = new (Event())('Incident Lock Available', setOf_0(requiresRole(Companion_getInstance_0(), MemberRole_Manager_getInstance())), 'Project Lock Available');
        this.e9h_1 = new (Event())('Settlement Documents Added', setOf_0(requiresRole(Companion_getInstance_0(), MemberRole_Manager_getInstance())));
        this.f9h_1 = new (Event())('Project Unlock Requested', setOf_0(requiresRole(Companion_getInstance_0(), MemberRole_Manager_getInstance())));
        this.g9h_1 = new (Event())('Unlock Request Accepted', setOf_0(requiresRole(Companion_getInstance_0(), MemberRole_Manager_getInstance())));
        this.h9h_1 = new (Event())('Work Item Status Update');
        this.i9h_1 = new (Event())('New Note Activity', setOf_0('FOR HOMEOWNERS EXCLUSIVELY'));
        this.j9h_1 = new (Event())('New Tasks Created', setOf_0('FOR HOMEOWNERS EXCLUSIVELY'));
        this.k9h_1 = new (Event())('Tasks Completed', setOf_0('FOR HOMEOWNERS EXCLUSIVELY'));
        this.l9h_1 = new (WithReminders())('LineItem Completion Message Sent', setOf([get_REQUIRED(Companion_getInstance_0()), requiresRole(Companion_getInstance_0(), MemberRole_Manager_getInstance())]), VOID, VOID, 'New Work Item Responses');
        this.m9h_1 = new (Event())('New Comments', setOf_0(requiresRole(Companion_getInstance_0(), MemberRole_Manager_getInstance())));
        this.n9h_1 = new (Event())('Work Item Lock Available', setOf_0(requiresRole(Companion_getInstance_0(), MemberRole_Manager_getInstance())), 'Lock Available');
        this.o9h_1 = new (WithReminders())('Homeowner Connect Bank Account', setOf_0('FOR HOMEOWNERS EXCLUSIVELY'), VOID, VOID, 'Connect Bank Account');
        this.p9h_1 = new (WithReminders())('Contractor Connect Bank Account', setOf(['FOR CONTRACTORS EXCLUSIVELY', requiresRole(Companion_getInstance_0(), MemberRole_Admin_getInstance())]), VOID, VOID, 'Connect Bank Account');
        this.q9h_1 = new (WithReminders())('Escrow Deposit Requested', setOf(['FOR HOMEOWNERS EXCLUSIVELY', get_HOMEOWNER_REQUIRED(Companion_getInstance_0())]), VOID, VOID, VOID, 'Escrow Deposit Reminders');
        this.r9h_1 = new (Event())('Escrow Funds Received', setOf_0('FOR HOMEOWNERS EXCLUSIVELY'));
        this.s9h_1 = new (Event())('Escrow Fully Funded', setOf_0(requiresRole(Companion_getInstance_0(), MemberRole_Manager_getInstance())));
        this.t9h_1 = new (WithReminders())('Draw Ready', setOf(['FOR HOMEOWNERS EXCLUSIVELY', get_HOMEOWNER_REQUIRED(Companion_getInstance_0())]), VOID, VOID, VOID, 'Draw Review Reminders');
        this.u9h_1 = new (Event())('Draw Work Item(s) Approved', setOf(['FOR CONTRACTORS EXCLUSIVELY', requiresRole(Companion_getInstance_0(), MemberRole_Manager_getInstance())]));
        this.v9h_1 = new (Event())('Draw Work Item(s) Auto-Approved', setOf(['FOR CONTRACTORS EXCLUSIVELY', requiresRole(Companion_getInstance_0(), MemberRole_Manager_getInstance())]));
        this.w9h_1 = new (Event())('Draw Work Item(s) Waited', setOf(['FOR CONTRACTORS EXCLUSIVELY', requiresRole(Companion_getInstance_0(), MemberRole_Manager_getInstance())]));
        this.x9h_1 = new (Event())('Draw Fully Approved', setOf(['FOR CONTRACTORS EXCLUSIVELY', requiresRole(Companion_getInstance_0(), MemberRole_Manager_getInstance())]));
        this.y9h_1 = new (WithReminders())('Change Request Published', setOf(['FOR HOMEOWNERS EXCLUSIVELY', get_HOMEOWNER_REQUIRED(Companion_getInstance_0())]), VOID, VOID, 'Change Review Ready');
        this.z9h_1 = new (Event())('Pending Line Item Approved', setOf(['FOR CONTRACTORS EXCLUSIVELY', requiresRole(Companion_getInstance_0(), MemberRole_Manager_getInstance())]));
        this.a9i_1 = new (Event())('Pending Line Item Rejected', setOf(['FOR CONTRACTORS EXCLUSIVELY', requiresRole(Companion_getInstance_0(), MemberRole_Manager_getInstance())]));
        this.b9i_1 = new (Event())('Pending Item Change Approved', setOf(['FOR CONTRACTORS EXCLUSIVELY', requiresRole(Companion_getInstance_0(), MemberRole_Manager_getInstance())]));
        this.c9i_1 = new (Event())('Pending Item Change Rejected', setOf(['FOR CONTRACTORS EXCLUSIVELY', requiresRole(Companion_getInstance_0(), MemberRole_Manager_getInstance())]));
        this.d9i_1 = new (Event())('ChangeRequest Fully Approved', setOf(['FOR CONTRACTORS EXCLUSIVELY', requiresRole(Companion_getInstance_0(), MemberRole_Manager_getInstance())]), 'Change Fully Approved');
        this.e9i_1 = new (Event())('ChangeRequest Fully Rejected', setOf(['FOR CONTRACTORS EXCLUSIVELY', requiresRole(Companion_getInstance_0(), MemberRole_Manager_getInstance())]), 'Change Fully Rejected');
        this.f9i_1 = new (WithReminders())('Line Item Sign-Off Requested', setOf(['FOR HOMEOWNERS EXCLUSIVELY', get_HOMEOWNER_REQUIRED(Companion_getInstance_0())]), VOID, VOID, 'Sign-Off Requested');
        this.g9i_1 = new (Event())('Work Item Auto-Completed', setOf_0(requiresRole(Companion_getInstance_0(), MemberRole_Manager_getInstance())));
        this.h9i_1 = new (WithReminders())('Final Completion Requested', setOf(['FOR HOMEOWNERS EXCLUSIVELY', get_HOMEOWNER_REQUIRED(Companion_getInstance_0())]), VOID, VOID, 'Final Completion Requested');
        this.i9i_1 = new (Event())('Project Auto-Completed', setOf_0(requiresRole(Companion_getInstance_0(), MemberRole_Manager_getInstance())));
        this.j9i_1 = new (Event())('Funds Released Pending', setOf(['FOR CONTRACTORS EXCLUSIVELY', requiresRole(Companion_getInstance_0(), MemberRole_Manager_getInstance())]));
        this.k9i_1 = new (Event())('Funds Released Confirmed', setOf_0(requiresRole(Companion_getInstance_0(), MemberRole_Manager_getInstance())));
        this.l9i_1 = new (Event())('Refund Ready to Claim', setOf_0('FOR HOMEOWNERS EXCLUSIVELY'), 'Funds Ready for Disbursement');
        this.m9i_1 = new (Event())('Refund Check Processing', setOf_0('FOR HOMEOWNERS EXCLUSIVELY'), 'Check Mailed');
        this.n9i_1 = new (Event())('Refund Direct Deposit Processing', setOf_0('FOR HOMEOWNERS EXCLUSIVELY'));
        this.o9i_1 = new (Event())('Refund Check Mailed', setOf_0('FOR HOMEOWNERS EXCLUSIVELY'));
        this.p9i_1 = new (Event())('Refund Direct Deposit Processed', setOf_0('FOR HOMEOWNERS EXCLUSIVELY'));
      }
    }
    initMetadataForObject($, 'SharedEvents');
    SharedEventsClass = $;
  }
  return SharedEventsClass;
}
var SharedEvents_instance;
function SharedEvents_getInstance() {
  if (SharedEvents_instance === VOID)
    new (SharedEvents())();
  return SharedEvents_instance;
}
function get_REQUIRED(_this__u8e3s4) {
  return 'REQUIRED';
}
function get_HOMEOWNER_REQUIRED(_this__u8e3s4) {
  return 'HOMEOWNER REQUIRED';
}
function get_CONTRACTOR_REQUIRED(_this__u8e3s4) {
  return 'CONTRACTOR REQUIRED';
}
function get_roleRequirement(_this__u8e3s4) {
  // Inline function 'kotlin.collections.find' call
  var tmp0 = _this__u8e3s4.w8l_1;
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      if (startsWith(element, 'ROLE:')) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var tmp0_safe_receiver = tmp$ret$1;
  switch (tmp0_safe_receiver == null ? null : substringAfter(tmp0_safe_receiver, 'ROLE:')) {
    case 'Admin':
      return MemberRole_Admin_getInstance();
    case 'Manager':
      return MemberRole_Manager_getInstance();
    case 'Employee':
      return MemberRole_Employee_getInstance();
    default:
      return null;
  }
}
function displayName(_this__u8e3s4, name) {
  return 'DISPLAY_NAME:' + name;
}
function requiresRole(_this__u8e3s4, role) {
  return 'ROLE:' + role.a4_1;
}
//region block: exports
export {
  get_CONTRACTOR_REQUIRED as get_CONTRACTOR_REQUIRED34hzo4f48qqcw,
  get_HOMEOWNER_REQUIRED as get_HOMEOWNER_REQUIREDhb3x1wu860rc,
  get_REQUIRED as get_REQUIRED1bmfj0gf2ut8d,
  Event as Event1b89my6urnj4w,
  WithReminders as WithReminders3bc704fti0zb0,
  get_roleRequirement as get_roleRequirementzb3lvemsijd7,
  SharedEvents_getInstance as SharedEvents_getInstance1170khu4x8la2,
};
//endregion

//# sourceMappingURL=notificationHelpers.mjs.map
